export const STOCK_LOT_BALANCE = 'StockLotBalance';
//# sourceMappingURL=stock-lot-balance.js.map